module.exports = __webpack_public_path__ + "img/purple.2eb11e0e.svg";